import axios from 'axios'

const TransferService = {
  async get (params = {}) {
    return axios.get('ro/inter-branch-transfer/requests', { params })
  },

  async histories (params = {}) {
    return axios.get('ro/reports/inter-branch-transfer/request-histories', { params })
  },

  async show (id) {
    return axios.get(`ro/inter-branch-transfer/requests/${id}`)
  },

  async post (params = {}) {
    return axios.post('ro/inter-branch-transfer/requests', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`ro/inter-branch-transfer/requests/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`ro/inter-branch-transfer/requests/${data.id}`, { data })
  }
}

export default TransferService
